import './index.scss';

interface EfMessageLRProps {
    /**
     * 左标题
     */
    lTitle: any;
    /**
     * 右标题
     */
    rTitle: any;
    /**
     * 右提示语
     */
    rTips?: string;
}

/**
 * 维护:谢保林
 *
 * 左右标题
 */
const EfMessageLR: React.FC<EfMessageLRProps> = ({ lTitle, rTitle, rTips }) => {
    const prefixCls = `ef-message-l-r`;
    return (
        <div className={`ef-message-l-r`}>
            <div className="ef-message-l-r-l">{lTitle}</div>
            <div className="ef-message-l-r-r">
                {rTitle && <div className="ef-message-l-r-r-line1">{rTitle}</div>}
                {rTips && <div className="ef-message-l-r-r-line2">{rTips}</div>}
            </div>
        </div>
    );
};
export default EfMessageLR;
